export const ZIP_TRANSLATIONS = {
    "cs": {
        "zipLabel": "Poštovní smerovací císlo",
        "zipRequiredMessage": "Povinný údaj",
        "zipInvalidMessage": "Illegal characters."
    },
    "da": {
        "zipLabel": "Postnummer",
        "zipRequiredMessage": "Dette felt skal udfyldes.",
        "zipInvalidMessage": "Du har indtastet et ugyldigt postnummer."
    },
    "de": {
        "zipLabel": "Postleitzahl",
        "zipRequiredMessage": "Dieses Feld muss ausgefüllt werden.",
        "zipInvalidMessage": "Sie haben eine ungültige Postleitzahl angegeben."
    },
    "de_CH": {
        "zipInvalidMessage": "Dieses Feld akzeptiert nur die Zeichen A-Z, 0-9."
    },
    'en': {
        'zipLabel': 'Postal Code',
        'zipInvalidMessage': 'You have entered an invalid Postal Code.',
        'zipRequiredMessage': 'This field is required.',
        'zipPlaceholder': 'Post Code'
    },
    en_DE: {
        zipLabel: 'Post Code'
    },
    en_ES: {
        zipLabel: 'Post Code'
    },
    en_FR: {
        zipLabel: 'Post Code'
    },
    en_GB: {
        zipLabel: 'Post Code'
    },
    en_HU: {
        zipLabel: 'Post Code'
    },
    en_NO: {
        zipLabel: 'Post Code'
    },
    "es": {
        "zipLabel": "Código Postal",
        "zipRequiredMessage": "Es una área requerida",
        "zipInvalidMessage": "Ud ha entrado un código de factura postal inválido"
    },
    "es_ES": {
        "zipRequiredMessage": "Es un campo obligatorio",
        "zipInvalidMessage": "El código postal que ha puesto no es correcto."
    },
    "es_VE": {
        "zipRequiredMessage": "Es una área requeria",
        "zipInvalidMessage": "Código postal incorrecto."
    },
    "fi": {
        "zipLabel": "Postinumero",
        "zipRequiredMessage": "Tämä kenttä on pakollinen.",
        "zipInvalidMessage": "Olet syöttänyt virheellisen postinumeron."
    },
    "fr": {
        "zipLabel": "Code postal",
        "zipRequiredMessage": "Ceci est un champ obligatoire.",
        "zipInvalidMessage": "Vous avez saisi un code postal invalide."
    },
    "fr_CA": {
        "zipLabel": "Code Postal"
    },
    "fr_CH": {
        "zipInvalidMessage": "Ce champ ne peut contenir que des chiffres romains (IV, V, X)."
    },
    "hu": {
        "zipLabel": "Irányítószám",
        "zipRequiredMessage": "E mező kitöltése kötelező.",
        "zipInvalidMessage": "Az Ön által megadott irányítószám hibás."
    },
    "in": {
        "zipLabel": "Post Code",
        "zipRequiredMessage": "This field is required.",
        "zipInvalidMessage": "You have entered an invalid Post Code."
    },
    "is": {
        "zipLabel": "Póstnúmer",
        "zipRequiredMessage": "Þessa eyðu má ekki skilja eftir auða.",
        "zipInvalidMessage": "Þú hefur skráð inn ógilt póstnúmer."
    },
    "it": {
        "zipLabel": "CAP",
        "zipRequiredMessage": "Questo è un campo obbligatorio.",
        "zipInvalidMessage": "Avete immesso un C.A.P. invalido."
    },
    "it_CH": {
        "zipRequiredMessage": "Questo campo è obbligatorio.",
        "zipInvalidMessage": "Questo campo può contenere solo caratteri A-Z, 0-9."
    },
    "iw": {
        "zipLabel": "מיקוד",
        "zipRequiredMessage": "This field is required."
    },
    "ja": {
        "zipLabel": "郵便番号：（例：123-1234）",
        "zipRequiredMessage": "この項目は必須です。",
        "zipInvalidMessage": "入力された郵便番号は無効です。"
    },
    "ms": {
        "zipLabel": "Post Code",
        "zipRequiredMessage": "This field is required.",
        "zipInvalidMessage": "You have entered an invalid Post Code."
    },
    "nl": {
        "zipLabel": "Postcode",
        "zipRequiredMessage": "Dit veld is verplicht.",
        "zipInvalidMessage": "U hebt een ongeldige postcode ingevoerd."
    },
    "nl_NL": {
        "zipRequiredMessage": "Dit is een verplicht veld.",
        "zipInvalidMessage": "In dit veld mogen alleen Romeinse cijfers staan (IV, V, X)."
    },
    "no": {
        "zipLabel": "Postnummer",
        "zipRequiredMessage": "Dette er et obligatorisk felt.",
        "zipInvalidMessage": "Ugyldig postnummer"
    },
    "pl": {
        "zipLabel": "Kod pocztowy",
        "zipRequiredMessage": "To pole należy obowiązkowo wypełnić.",
        "zipInvalidMessage": "Wprowadzony kod pocztowy nie jest ważny."
    },
    "pt": {
        "zipLabel": "CEP",
        "zipRequiredMessage": "Campo é obrigatório",
        "zipInvalidMessage": "Você digitou um CEP inválido."
    },
    "pt_PT": {
        "zipLabel": "Código Postal: (XXXX-XXX)"
    },
    "ro": {
        "zipLabel": "Cod poştal",
        "zipRequiredMessage": "Acest câmp este obligatoriu.",
        "zipInvalidMessage": "Aţi introdus un cod poştal invalid."
    },
    "ru": {
        "zipLabel": "Почтовый индекс",
        "zipRequiredMessage": "Это поле обязательно для заполнения.",
        "zipInvalidMessage": "Вы ввели неверный почтовый индекс."
    },
    "ru_UA": {
        "zipLabel": "Индекс"
    },
    "sk": {
        "zipLabel": "PSC",
        "zipRequiredMessage": "Je potrebné vyplniť toto pole.",
        "zipInvalidMessage": "Toto pole môže obsahovať iba znaky A-Z, 0-9."
    },
    "sv": {
        "zipLabel": "Postnummer",
        "zipRequiredMessage": "Detta fält måste ifyllas.",
        "zipInvalidMessage": "Du har fyllt i ett ogiltigt postnummer."
    },
    "th": {
        "zipLabel": "รหัสไปรษณีย์",
        "zipRequiredMessage": "กรุณากรอกข้อมูลนี้ให้ครบถ้วน",
        "zipInvalidMessage": "รหัสไปรษณีย์ไม่ถูกต้อง"
    },
    "th_SE": {
        "zipRequiredMessage": "จำเป็นต้องกรอกช่องนี้",
        "zipInvalidMessage": "คุณกรอกรหัสไปรษณีย์ไม่ถูกต้อง"
    },
    "th_TH": {
        "zipLabel": "รหัสไปรษณีย์ "
    },
    "tr": {
        "zipLabel": "Posta Kodu",
        "zipRequiredMessage": "Bu alanı doldurmak zorunludur.",
        "zipInvalidMessage": "Geçersiz bir Posta Kodu girdiniz."
    },
    "uk": {
        "zipLabel": "Індекс",
        "zipRequiredMessage": "Це поле є обов язковим для заповнення.",
        "zipInvalidMessage": "Ви ввели невірний поштовий індекс."
    },
    "vi": {
        "zipLabel": "Bưu chánh",
        "zipRequiredMessage": "Trường thông tin bắt buộc",
        "zipInvalidMessage": "You have entered an invalid Post Code."
    },
    'zh': {
        'zipLabel': '邮政编码',
        'zipInvalidMessage': '这个字段是无效的',
        'zipRequiredMessage': '这是必填栏',
        'zipPlaceholder': '邮政编码'
    }
};
